import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { DeliveryService } from 'src/app/services/delivery.service';
import { DeluxyDotComSalesService } from 'src/app/services/deluxy-dot-com-sales.service';
import { DeluxyDotComSaleFormDialogComponent } from '../deluxy-dot-com-sale-form-dialog/deluxy-dot-com-sale-form-dialog.component';

@Component({
  selector: 'app-deluxy-dot-com-sale',
  templateUrl: './deluxy-dot-com-sale.component.html',
  styleUrls: ['./deluxy-dot-com-sale.component.scss']
})
export class DeluxyDotComSaleComponent implements OnInit {

  limit: number;
  page: number;
  count: number;
  maxPage: number;
  filtered: {};
  orders: any[] = [];
  deluxyDotComSaleForm: any;
  order: {};
  myjson: any = JSON;
  groups: any;
  selected: string = 'active';
  settings = {
    active: {
      title: "deluxy.com Vendite",
    },
    inactive: {
      title: "Storico deluxy.com Vendite",
    }
  };
  defaultPage = 1;
  defaultLimit = 100;
  defaultOrder = { 'DeluxyDotComSales.actualOrderId': 'DESC' };
  btnDisable: boolean = false;

  constructor(
    private authStatusService: AuthStatusService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private router: Router,
    private deliveryService: DeliveryService,
    private deluxyDotComSalesService: DeluxyDotComSalesService,
  ) {
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
    this.manageDeluxyDotComSaleFilterForm();
  }

  async ngOnInit() {
    this.selected = !this.route.snapshot.data['active'] ? 'inactive' : 'active';
    await this.filter();
  }

  manageDeluxyDotComSaleFilterForm() {
    this.deluxyDotComSaleForm = new FormGroup({
      'DeluxyDotComSales.orderId': new FormControl(''),
      'DeluxyDotComSales.actualOrderId': new FormControl(''),
      'DeluxyDotComSales.deliveryDate_from': new FormControl(''),
      'DeluxyDotComSales.deliveryDate_to': new FormControl(''),
      'DeluxyDotComSales.channel': new FormControl(''),
      'DeluxyDotComSales.total': new FormControl(''),
      'DeluxyDotComSales.paymentStatus': new FormControl(''),
      'DeluxyDotComSales.fullFillmentStatus': new FormControl(''),
      'DeluxyDotComSales.deliveryMethod': new FormControl(''),
      'DeluxyDotComSales.address': new FormControl(''),
      'DeluxyDotComSales.phone': new FormControl(''),
      'DeluxyDotComSales.deliveryDate': new FormControl(''),
      'DeluxyDotComSales.vendor': new FormControl(''),
      'DeluxyDotComSales.status': new FormControl(''),
    });
  }

  async filter() {
    let filterForm = (new FormGroupToObject()).transform(this.deluxyDotComSaleForm);
    this.filtered = {};
    if (filterForm['DeluxyDotComSales.orderId'])
      this.filtered['DeluxyDotComSales.orderId'] = filterForm['DeluxyDotComSales.orderId'];
    if (filterForm['DeluxyDotComSales.actualOrderId'])
      this.filtered['DeluxyDotComSales.actualOrderId'] = filterForm['DeluxyDotComSales.actualOrderId'];
    if (filterForm['DeluxyDotComSales.channel'])
      this.filtered['DeluxyDotComSales.channel'] = { operator: 'like', values: [`%${filterForm['DeluxyDotComSales.channel']}%`] };
    if (filterForm['DeluxyDotComSales.total'])
      this.filtered['DeluxyDotComSales.total'] = { operator: 'like', values: [`%${filterForm['DeluxyDotComSales.total']}%`] };
    if (filterForm['DeluxyDotComSales.paymentStatus'])
      this.filtered['DeluxyDotComSales.paymentStatus'] = { operator: 'like', values: [`%${filterForm['DeluxyDotComSales.paymentStatus']}%`] };
    if (filterForm['DeluxyDotComSales.fullFillmentStatus'])
      this.filtered['DeluxyDotComSales.fullFillmentStatus'] = { operator: 'like', values: [`%${filterForm['DeluxyDotComSales.fullFillmentStatus']}%`] };
    if (filterForm['DeluxyDotComSales.deliveryMethod'])
      this.filtered['DeluxyDotComSales.deliveryMethod'] = { operator: 'like', values: [`%${filterForm['DeluxyDotComSales.deliveryMethod']}%`] };
    if (filterForm['DeluxyDotComSales.address'])
      this.filtered['DeluxyDotComSales.address'] = { operator: 'like', values: [`%${filterForm['DeluxyDotComSales.address']}%`] };
    if (filterForm['DeluxyDotComSales.phone'])
      this.filtered['DeluxyDotComSales.phone'] = { operator: 'like', values: [`%${filterForm['DeluxyDotComSales.phone']}%`] };
    if (filterForm['DeluxyDotComSales.deliveryDate_from'])
      this.filtered['DeluxyDotComSales.deliveryDate'] = { operator: 'moreThanOrEqual', values: [filterForm['DeluxyDotComSales.deliveryDate_from']] };
    if (filterForm['DeluxyDotComSales.deliveryDate_to'])
      this.filtered['DeluxyDotComSales.deliveryDate'] = { operator: 'lessThan', values: [filterForm['DeluxyDotComSales.deliveryDate_to']] };
    if (filterForm['DeluxyDotComSales.deliveryDate_from'] && filterForm['DeluxyDotComSales.deliveryDate_to'])
      this.filtered['DeluxyDotComSales.deliveryDate'] = { operator: 'between', values: [filterForm['DeluxyDotComSales.deliveryDate_from'], filterForm['DeluxyDotComSales.deliveryDate_to']] };
    if (filterForm['DeluxyDotComSales.vendor'])
      this.filtered['DeluxyDotComSales.vendor'] = { operator: 'like', values: [`%${filterForm['DeluxyDotComSales.vendor']}%`] };
    if (filterForm['DeluxyDotComSales.status'])
      this.filtered['DeluxyDotComSales.status'] = { operator: 'like', values: [`%${filterForm['DeluxyDotComSales.status']}%`] };

    await this.getDeluxyDotComOrders();
  }

  async getDeluxyDotComOrders(limit?: number, page?: number, order?: {}) {
    this.page = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
    this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
    this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;
    let promiseResult = null;
    promiseResult = this.selected == 'active' ?
      this.deluxyDotComSalesService.getDeluxyDotComOrders(this.page, this.limit, this.order, this.filtered) :
      this.deluxyDotComSalesService.getDeluxyDotComOrdersHistory(this.page, this.limit, this.order, this.filtered);
    promiseResult.then((res) => {
      this.orders = res.orders;
      this.count = res.count;
      this.maxPage = Math.ceil(this.count / this.limit);
    }).catch((err) => {
      console.log("err", err)
    })
  }

  async confirmSale(saleOrder: any) {
    if (this.groups.includes('admin') || this.groups.includes('operation') || this.groups.includes('teamleader')) {
      let delivery = await this.deliveryService.getDeliveryWithOrderId(saleOrder?.orderId, saleOrder?.realOrderNumber);
      if (delivery) {
        this._snackBar.open(`This is unique product sale. Delivery has been created. Partner is still accpet or reject the sale`, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        });
        return false;
      }
      let ref = this.dialog.open(DeluxyDotComSaleFormDialogComponent, { width: '80vw', data: { saleOrder } });
      ref.afterClosed().subscribe(async (result) => {
        if (result?.delivery) {
          await this.getDeluxyDotComOrders();
        }
      });
    } else {
      return false;
    }
  }

  async refuseSale(orderId: number) {
    if (!confirm(`Sei sicuro di voler rifiutare l'ordine di Shopify?`))
      return false;
    let promiseResult = await this.deluxyDotComSalesService.refuseSaleByAdmin(orderId);
    if (promiseResult.success) {
      this._snackBar.open(`L'ordine di Shopify è stato rifiutato. Puoi controllare nella cronologia`, 'Chiudi', {
        direction: "ltr",
        duration: 2000,
        horizontalPosition: "center",
        politeness: "assertive",
        verticalPosition: "top"
      });
      await this.getDeluxyDotComOrders();
    } else {
      this._snackBar.open(`Qualcosa è andato storto`, 'Chiudi', {
        direction: "ltr",
        duration: 2000,
        horizontalPosition: "center",
        politeness: "assertive",
        verticalPosition: "top"
      });
    }
  }

  async stopSaleAutomation(sale: any) {
    if (!confirm(`Are You Sure to Stop Sale Automation ${sale?.platform?.toLowerCase()}?`))
      return false;
    try {
      this.btnDisable = true;
      let id: number = sale?.id;
      let promiseResult = await this.deluxyDotComSalesService.stopSaleAutomation(id, sale);

      if (promiseResult.success) {
        this._snackBar.open(`Sale Automation has been Stopped.`, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        });
      } else {
        this._snackBar.open(`Something Went Wrong`, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        });
      }
      await this.getDeluxyDotComOrders();
    } catch (error) {
      this.btnDisable = false;
      this._snackBar.open(`Something Went Wrong ${error?.error?.message}`, 'Chiudi', {
        direction: "ltr",
        duration: 2000,
        horizontalPosition: "center",
        politeness: "assertive",
        verticalPosition: "top"
      });
    }
  }

  async resetFilter() {
    this.manageDeluxyDotComSaleFilterForm();
    await this.filter();
  }

  async navigate(event) {
    await this.getDeluxyDotComOrders(event.limit, event.page, this.order);
  }

  public async navigateOrder(attribute: string | string[]) {
    delete this.order['DeluxyDotComSales.updatedAt'];
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          this.order[attr] = 'DESC';
          break;
        case 'DESC':
          this.order[attr] = undefined;
          break;
        default:
          this.order = {}
          this.order[attr] = 'ASC';
          break;
      }
    }

    await this.navigatePage(this.limit, this.page, { order: this.order });
  }

  async navigatePage(limit: number, page: number, args: {} = {}) {
    args = this.escapeQueryStringParams(args);
    const previousArgs = Object.keys(args).length ? {} : this.route.snapshot.queryParams;
    const newParams = { ...previousArgs };
    newParams[`limit`] = limit;
    newParams[`page`] = page;
    this.router.navigate(this.route.snapshot.url.map(u => u.path), { queryParams: { ...newParams, ...args } }).then(async () => {
      await this.getDeluxyDotComOrders();
    });
  }

  private escapeQueryStringParams(args: {} = {}): {} {
    Object.keys(args).forEach(key => {
      switch (Object.prototype.toString.call(args[key])) {
        case '[object Number]':
        case '[object String]':
          break;
        case '[object Array]':
        case '[object Object]':
          args[key] = JSON.stringify(args[key]);
          break;
        default:
          delete args[key];
          break;
      }
    });
    return args;
  }

  public orderIcon(attribute: string | string[]): string {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          return 'fa-sort-up';
        case 'DESC':
          return 'fa-sort-down';
        default:
          return 'fa-sort';
      }
    }
  }

}
